import { useSelector } from "react-redux";
import GuidedSearchSingle from "../../../../../features/browse-search/components/GuidedSearchSingle";
import { hasRenderableGuidedSearch } from "../../../../../features/browse-search/components/GuidedSearch/normaliseVisualRefinements";
import { getGuidedSearchData } from "../../../../../state/modules/search";
import BaseCategoryPage from "../../../CategoryPage";

export const CategoryPage = (props) => {
  const guidedSearchData = useSelector(getGuidedSearchData);

  return (
    <BaseCategoryPage
      {...props}
      hideHeaderDescription={hasRenderableGuidedSearch(guidedSearchData)}
      topContent={<GuidedSearchSingle withCategoryDescription />}
    />
  );
};

export default CategoryPage;
